import { render, staticRenderFns } from "./VisitedLinksTab.vue?vue&type=template&id=2885e9dd&scoped=true"
import script from "./VisitedLinksTab.vue?vue&type=script&lang=js"
export * from "./VisitedLinksTab.vue?vue&type=script&lang=js"
import style0 from "./VisitedLinksTab.vue?vue&type=style&index=0&id=2885e9dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2885e9dd",
  null
  
)

export default component.exports